import './types';

import * as Sentry from '@sentry/react';
import axios from 'axios';

import { env } from '@lib/config/env';

export const api = axios.create({
  baseURL: env.API_BASE_URL,
  withCredentials: true, // Cookie-based JWT auth
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor - log errors and handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    const method = error.config?.method?.toUpperCase();

    console.error(`[API] Request failed: ${status} ${method} ${url}`, {
      status,
      url,
      method,
      data: error.response?.data,
    });

    // Report 5xx errors and network errors to Sentry for production observability
    if (!status || status >= 500) {
      Sentry.captureException(error, {
        tags: { api_url: url, api_method: method },
        extra: { response_data: error.response?.data },
      });
    }

    // Redirect to login on 401, but skip for pre-auth endpoints and account pages
    if (status === 401 && typeof window !== 'undefined') {
      const skipRedirect =
        error.config?.skipAuthRedirect ||
        window.location.pathname.includes('/account');

      if (!skipRedirect) {
        console.warn('[API] Authentication required, redirecting to login');
        const countryCode = window.location.pathname.split('/')[1] || 'tw';
        window.location.href = `/${countryCode}/account`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
